import i18n from 'i18next'
import html2canvas from 'html2canvas'

import variables from 'assets/styles/scss/shared/_variables.module.scss'

const saveImage = (img: string, fileNameKey: string) => {
  const link = document.createElement('a')
  const fileName = `${i18n.t(`reporting.fileName.${fileNameKey}`)}`
  if (typeof link.download === 'string') {
    link.href = img
    link.target = '_blank'
    link.download = fileName

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else {
    window.open(img)
  }
}

export const downloadAsImage = (
  type: string,
  fileNameKey: string,
  moreVertRef: React.RefObject<any>,
) => {
  // return if no reference is passed
  if (!moreVertRef) return

  const element = moreVertRef.current

  // create a link to donwload
  const bgColor: string =
    type == 'jpeg' ? variables.white : variables.transparent

  html2canvas(element, {
    allowTaint: true,
    onclone: (doc: any) => {
      const barChartContainer = doc?.getElementsByClassName(
        'horizontalChart-container',
      )
      const isContributionBarChart =
        fileNameKey === 'contributionTags' &&
        barChartContainer[0]?.style?.overflowY === 'scroll'
      const barStyle = {
        height: '100%',
        overflowY: 'auto',
      }
      const keyMetricsId = doc?.getElementById('key-metrics') // add space on top for key metrics

      switch (true) {
        case isContributionBarChart:
          barChartContainer[0].style = barStyle
          barChartContainer[0].closest('.MuiPaper-root').style.height = '100%'

          break
        case fileNameKey === 'keyMetrics':
          keyMetricsId.style.marginTop = '-0.8rem'
          break
        default:
          break
      }
    },

    backgroundColor: bgColor,
  })
    .then((canvas) => {
      // if value is missing, defaults to png
      const img = canvas.toDataURL(`image/${type}`)
      saveImage(img, fileNameKey)
    })
    .catch((error) => alert(`something went wrong!', ${error}`))
}
